<template>
  <el-drawer custom-class="competing_drawer" size="auto" v-model="competing_show" :direction="rtl">
    <div class="filter_list">
      <div class="filter_config_container" :style="{height: is_show ? '165px': '85px'}">
        <template v-for="item in filterConditionRef" :key="item.field">
          <div class="config_item">
            <div class="config_label">{{ item.field }} :</div>
            <div class="config_list flex flex_wrap">
              <span
                :class="[
                  !filterSelectedData[item.field].selectedText ? 'current' : '',
                ]"
                @click="changeFilterSelectedData(item.field, config, '')"
                style="padding: 0 10px"
                >不限</span
              >
              <span
                :class="[
                  filterSelectedData[item.field].selectedText == config.text
                    ? 'current'
                    : '',
                ]"
                v-for="config of item.list"
                :key="config.text"
                @click="
                  changeFilterSelectedData(item.field, config, config.text)
                "
                >{{ config.text }}</span
              >
            </div>
          </div>
        </template>
      </div>
      <div class="show_or_hide" @click="is_show = !is_show">
        <div class="show_or_hide_btn">
          <div>
            {{ is_show ? "点击收起" : "展开更多" }}
          </div>
          <div
            class="icon_sanjiao"
            :class="is_show ? 'zhankai' : 'shouqi'"
          ></div>
        </div>
      </div>
      <div class="filter_result_container">
        <el-table
          :data="carData"
          :cell-class-name="'center'"
          :header-row-class-name="'center table_header'"
          empty-text="暂无数据,敬请期待。"
        >
          <el-table-column
            v-for="attr of thRef"
            :label="attr.name"
            :prop="attr.type"
            :key="attr.type"
          >
            <template #default="scope">
              <template v-if="attr.type == 'model_img'">
                <img class="model_img" :src="scope.row[attr.type]" alt="" />
              </template>
              <template v-else-if="attr.type == 'brand'">
                {{ scope.row[attr.type] + scope.row.model_name }}
              </template>
              <span v-else :class="attr.class">
                {{ scope.row[attr.type] || "-" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="">
            <template #default="scope">
              <div
                v-if="isCompare(scope.row.id)"
                class="changeModelBtn"
                @click="changeModel(scope.row.id, 'add')"
              >
                <!-- <span class="addPlus">+</span> -->
                <span>加入竞品车型</span>
              </div>
              <div
                v-else
                class="changeModelBtn"
                @click="changeModel(scope.row.id, 'cancel')"
              >
                <!-- <span class="addPlus">x</span> -->
                <span>取消关注</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { 
  ref,
  reactive
} from "vue";
import {
  getCarFilterConfig,
  getCarLibrary,
  addCompareCar,
  getCompareCarList,
  delCompareCar,
} from "@/api_drive";
import {
  ElDrawer,
  ElTable,
  ElTableColumn,
  ElLoading,
  ElMessage
} from "element-plus";
export default {
  components:{
    ElDrawer,
    ElTable,
    ElTableColumn,
  },
  setup(props,{emit}){
    const competing_show = ref(false);
    //筛选项
    const filterConditionRef = ref([]);
    // 筛选项选中的数据
    const filterSelectedData = reactive({});
    //tab签th
    const thRef = ref([
      {
        type: "model_img",
        name: "",
      },
      {
        type: "brand",
        name: "车型",
      },
      // {
      //   type: "energy_type_str",
      //   name: "能源",
      // },
      // {
      //   type: "price",
      //   name: "售价",
      // },
      {
        type: "total_score",
        name: "综合得分",
        class: "orange",
      },
      {
        type: "top",
        name: "综合排名",
        class: "orange",
      },
    ]);
    // 获取筛选项
    const getCarFilterConfigData = () => {
      getCarFilterConfig().then((res) => {
        if (res.code == 200) {
          const { condition } = res.data;
          filterConditionRef.value = condition;
          for (let item of condition) {
            filterSelectedData[item.field] = {
              selectedText: "",
              params: {},
            };
          }
        }
      });
    };
    // 点击筛选项
    const changeFilterSelectedData = (type, data, selectedText) => {
      if (filterSelectedData[type].selectedText == selectedText) {
        return;
      }
      filterSelectedData[type].selectedText = selectedText;
      if (data) {
        filterSelectedData[type].params = data.params;
      } else {
        filterSelectedData[type].params = {};
      }
      currentPage.value = 1;
      count.value = 0;
      getCarData();
    };
    // 车型列表
    const count = ref(0);
    const currentPage = ref(1);
    const pageSize = ref(9999);
    const carData = ref([]);
    const compareIds = ref([]);
    const compareList = ref([]);
     // 获取车型列表数据
    const getCarData = () => {
      const loading = ElLoading.service({
        target:'.el-drawer__body',
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const data = {
        page: currentPage.value,
        rows: pageSize.value,
      };

      //重新请求list
      let params = {};
      for (let key in filterSelectedData) {
        Object.assign(params, filterSelectedData[key].params);
      }
      compareIds.value = [];
      getCompareCarList({ size: 9999 }).then((res) => {
        if (res.data.list) {
          res.data.list.forEach(function (model) {
            compareIds.value.push(parseInt(model.model_id));
          });
          compareList.value = res.data.list;
          getCarLibrary({
            ...data,
            ...params,
          }).then((res2) => {
            if (res2.code == 1) {
              count.value = res2.data.count;

              let list = [];
              res2.data.list.forEach(item=>{
                if(compareIds.value.indexOf(item.id*1) == -1){
                  list.push(item);
                }
              });
              carData.value = [...compareList.value,...list];
            }
            loading && loading.close();
          });
        }
      });
    };
    // 返回传参问题
    const changeModel = (model_id, type) => {
      if (type == "add") {
        addCompareCar({ model_id: model_id }).then((res) => {
          compareIds.value.push(model_id);
          if (res.code == 200) {
            getCarData();
            ElMessage.success("添加成功!");
            emit("compareChange");
          } else {
            ElMessage.error(res.message || "添加失败!");
          }
        });
      } else {
        delCompareCar({ model_id: model_id }).then((res) => {
          if (res.code == 200) {
            let index = compareIds.value.indexOf(model_id);
            if (index > -1) {
              compareIds.value.splice(index, 1);
            }
            getCarData();
            ElMessage.success("取消成功!");
            emit("compareChange");
          } else {
            ElMessage.error(res.message || "取消失败!");
          }
        });
      }
    };
    const isCompare = (model_id) => {
      return compareIds.value.indexOf(model_id*1) == -1;
    };
    const is_show = ref(false);

    getCarFilterConfigData();
    getCarData();

    return {
      competing_show,
      filterConditionRef,
      filterSelectedData,
      thRef,
      count,
      currentPage,
      pageSize,
      carData,
      changeFilterSelectedData,
      changeModel,
      isCompare,
      is_show,
      
    }

  }
}
</script>

<style lang="less" scoped>
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.addCompare {
  width: 133px;
  height: 35px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px #bcd8ff;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.addText {
  font-size: 16px;
  color: #7e7e7e;
  line-height: 21px;
}
.addIcon {
  width: 17px;
  height: 17px;
  border: 1px solid #3f8fff;
  border-radius: 17px;
  color: #3f8fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
}

.model_img {
  width: auto;
  height: 60px;
}

.orange {
  font-size: 14px;
  line-height: 19px;
}
.addPlus {
  width: 16px;
  height: 16px;
  border: 1px solid #3f8fff;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
.filter_config_container {
  width: 100%;
  font-size: 14px;
  color: #474747;
  height: auto;
  transition: height 500ms;
  position: relative;
  overflow: hidden;
  .config_item {
    line-height: 32px;
  }
  .config_label {
    float: left;
    margin: 5px 0;
    color: #474747;
    font-weight: bold;
  }
  .config_list {
    margin-left: 62px;
    span {
      margin: 8px;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      padding: 0 3px;
      white-space: nowrap;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }
      &:hover {
        background: #ebefff;
        color: #474747;
      }
      &.current {
        background: #1fbcbf;
        color: #fff;
      }
    }
  }
}
.filter_result_container {
  margin-top: 40px;
}
.changeModelBtn {
  cursor: pointer;
  color: #7d95f3;
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.el-tabs__header) {
  margin-bottom: 0;
}
:deep(.el-tabs__nav-wrap::after) {
  display: none;
}
:deep(.el-tabs__item) {
  height: 45px;
  font-size: 15px;
  // &.is-active, &:hover{
  //   font-weight: bold;
  //   color: #00CDFF;
  // }
}
:deep(.el-tabs__active-bar) {
  height: 3px;
  // background: #00CDFF;
  border-radius: 1px;
}
:deep(.center .cell) {
  text-align: center;
  color: #474747;
}
:deep(.table_header th) {
  background: #f5f7f9;
  font-weight: bold;
}
// .#F5F8FF{
//   background: #F5F8FF;
// }
:deep(.el-pagination) {
  margin-top: 40px;
  text-align: center;
  .btn-prev,
  .btn-next {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
.show_or_hide {
  width: 100%;
  height: 29px;
  border-radius: 0 0 20px 20px;
  border-bottom: solid 1px #dee8f6;
  background: #fff;
  position: relative;
  .show_or_hide_btn {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    color: #969696;
    background: #fff;
    .icon_sanjiao {
      width: 10px;
      height: 10px;
      margin-left: 7px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/zksq_sanjiao.png)
        no-repeat center center;
      background-size: 8px;
      transition: all 500ms;
      &.shouqi {
        transform: rotateZ(180deg);
      }
    }
  }
}
:deep(.el-table td) {
  padding: 6px 0;
}

.filter_list{
  width: 1000px;
  padding: 0 30px;
}
</style>
<style>
.el-drawer__body{
  height: 100%;
  overflow-y: auto;
}
</style>